if (!customElements.get('hubspot-button')) {
  customElements.define('hubspot-button', class HubspotButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClickHandler.bind(this))
    }
    onClickHandler(event) {
      event.preventDefault();
      typeof HubSpotConversations !== 'undefined' && HubSpotConversations?.widget?.open();
    }
  });
}
